import supportsWoff2 from 'woff2-feature-test';

window.supportsWoff2 = supportsWoff2;
